// Gestion du no-js
var html = document.documentElement;
html.classList.remove("no-js");

// Devices Media Queries
let mobile = window.matchMedia('(min-width: 0px) and (max-width: 768px)');
let tablet = window.matchMedia('(min-width: 769px) and (max-width: 1200px)');
let desktop = window.matchMedia('(min-width: 1201px)');


import './lib/breakpoints.js';
// import './lib/skip-link-focus-fix.js';
// import './lib/header-programme.js';

// Dropdown pour FAQ
import './lib/faq.js';

//Initialisation des slider
// import './lib/slider.js';

// Block
// import './block/core-block-extend.js';
// import './block/block-variation.js';

// Dropdown pour les lots
// import './lib/lots-dropdown.js';

// Dropdown pour les lots
import './lib/map-programme.js';

// GSAP for animation
// import '../../../node_modules/gsap/dist/gsap.min.js';
// import '../../../node_modules/gsap/dist/ScrollTrigger.min.js';
// import '../../../node_modules/gsap/dist/ScrollToPlugin.min.js';
// gsap.registerPlugin(ScrollTrigger); 
// gsap.registerPlugin(ScrollToPlugin); 

// Scroller FX
// import './lib/scroller.js';

// Swiper
import Swiper from 'swiper';
import { Navigation, Pagination, Manipulation, Mousewheel } from 'swiper/modules';



document.addEventListener('DOMContentLoaded', () => {
// Prepare YT API
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// Control YT videos
function onYouTubeIframeAPIReady() {
  window.programmeVideos = {};
  console.log(document.querySelectorAll('iframe[src^="https://www.youtube.com"]'));
  // $('iframe[src^="https://www.youtube.com"]').each((i, e) => {
  document.querySelectorAll('iframe[src^="https://www.youtube.com"]').forEach((el) => {
    let id = $(e).prop('id');
    window.programmeVideos[id] = new YT.Player(el.getAttribute('id'));
  });
}
  // Pour chaque bouton avec la classe .is-style-bigger
  $('.is-style-bigger .wp-element-button').each(function () {
    $(this).append('<span class="icon-fleche-droite"></span>');
  });

  if (!desktop?.matches) {
    $('.header-banner-programme').css("background-image", "none");
    $('.header-banner-programme .img-banner-programme').css({ 'display': 'block' });
  }

  // Functions to open and close a modal
  function openModal(el, swiperSelector) {
    if (el) {
      // toggleVideoPlay(el, 'start')
      closeAllModals(el);

      if (swiperSelector) {
        const swiper = initSwiper(swiperSelector);
      }

      // $('html').addClass('is-clipped');
      // if (!$(el).hasClass('gallery')) $(el).appendTo($('body'));
      el.classList.add('is-active');

      // Move Media gallery buttons
      //   if ($(".programme-utilities").length) {
      //     $(".programme-utilities").addClass("is-active");
      //     window.scrollTo(0, 0);
      //   }

    }
  }

  function closeModal(el) {

    // toggleVideoPlay(el, 'pause');
    el.classList.remove('is-active');

    // Move Media gallery buttons
    if ($(".programme-utilities").length) $(".programme-utilities").removeClass("is-active");

    $('html').removeClass('is-clipped');

  }

  function closeAllModals(el) {
    (document.querySelectorAll('.modal') || []).forEach((modal) => {
      if (el !== 'undefined' && el != modal) closeModal(modal);
    });
  }

  function initSwiper(selector) {
    return new Swiper(selector, {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },

      autoHeight: true,
      centeredSlides: true,
      loop: true,
      speed: 400,
      slidesPerView: 1,
    })
  }

  // Used in React, declared globally
  // Create custom events
  var modalOpened;
  var modalClosed;
  window.modalTriggerHandler = (e) => {
    e.preventDefault();
    const modal = $(e.target).data('target') ?? $(e.target).find('a').attr('rel') ?? $(e.target).attr('rel');
    if (modal) {
      const target = document.getElementById(modal);
      if (modal.includes("realisation")) {
        openModal(target, `#${modal} .swiper`);
      }
      else openModal(target);
      // document.dispatchEvent(modalOpened);
      target.dispatchEvent(new CustomEvent('modalOpened'))
    }
  }
  // Bind js-modal-trigger event for new elements..
  $('body').on('click', '.js-modal-trigger', window.modalTriggerHandler);

  $('body').on('click', '.modal-background, .modal-close, .modal-card-head .delete, .modal-card-foot .button', closeModalTriggerHandler);
  function closeModalTriggerHandler(e) {
    e.stopImmediatePropagation();
    const target = $(e.target).closest('.modal').get(0);
    closeModal(target);
    // document.dispatchEvent(modalClosed);
    target.dispatchEvent(new CustomEvent('modalClosed'))
  }

  // Add a keyboard event to close all modals
  document.addEventListener('keydown', (event) => {
    const e = event || window.event;

    if (e.keyCode === 27) { // Escape key
      closeAllModals();
    }
  });

  if ($('#single-programme-menu').length) {
    let anchorOffset = $('#masthead').outerHeight() + $('body > .banner').outerHeight();
    $('#single-programme-menu').on('click', 'a', (e) => {
      e.preventDefault();
      let $target = $($(e.target).attr('href'));
      $('body, html').animate({ scrollTop: Math.round($target.offset().top - $target.outerHeight() - anchorOffset - 50) }, 1000);
      return false;

    });
  }

  // Move gallery buttons on mobile
  if (!tablet.matches && !desktop.matches && $('.programme-utilities').length) {
    $target = $('.banner-content');
    $('.programme-utilities').insertBefore($target.find('.single-programme-buttons'));
    $target.css({ position: 'relative' });
  }

  // Fix Avant Premiere
  if (!desktop.matches && $('article.sticky').length) {
    $('article.sticky').removeClass('sticky');
  }

  // Give plans/plaquettes data to Window Object
  // Further process is done in filter "spprom_hubspot_payload_filter"
  // See template-function.php
  if ($('body.single-programme').length) {
    $.get(sporting.ajaxUrl, { action: 'get_programme_datas' }, (response) => {
      window.region = response?.region;
      window.currentPlaquette = response?.plaquette ? response.plaquette.replace(' ', '_') : undefined;
      window.currentProgramme = response?.programme;
    });
    $('body.single-programme .lot-by-typo [data-target]').on('click', (e) => {
      let $el = $(e.target);
      window.currentLot = $el.data('label');
      window.currentPlan = encodeURI($el.data('plan'));
      window.currentDispositif = $el.data('dispositif');
      window.currentTypologie = $el.data('typologie');
    });

  }

  // Slider vertical
  if (!mobile.matches && $('body .entry-content .slider-vertical').length) {

    const tooltip = [];
    const verticalSwiper = new Swiper('body .entry-content .slider-vertical', {
      modules: [Navigation, Pagination, Mousewheel],
      // wrapperClass: 'wp-block-group__inner-container',
      slideClass: 'wp-block-columns',
      slidesPerView: 1,
      mousewheel: {
        releaseOnEdges: true,
      },
      pagination: {
        el: '.slider-vertical-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className}"><span class="tooltip"><span class="tooltip-content">${tooltip[index]}</span></span></span>`;
        }
      },
      direction: 'vertical',
      on: {
        beforeInit: (e) => {
          $(".slider-vertical .wp-block-column figure > img").each(function (i) {
            tooltip.push($(this).attr('alt'));
          });
          let menuHeight = Math.round($('.wp-site-blocks > header.site-header').outerHeight() + $('.wp-site-blocks > .site-breadcrumbs').outerHeight() + $('.wp-site-blocks > .wp-block-cover.alignfull').outerHeight());
          // $('.slider-vertical .wp-block-group__inner-container').height($(window).height() - menuHeight);
          $('.slider-vertical').height($(window).height() - menuHeight);
        }
      },
    });
  };

  // Slider timeline
  if ($("body .timeline-container > .swiper-container-wrapper > .swiper")) {
    var mySwiper = new Swiper(".timeline-container > .swiper-container-wrapper > .swiper", {
      modules: [Navigation, Pagination],
      autoHeight: true,
      mousewheel: true,
      direction: "horizontal",
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar"
      },
      loop: false,
      effect: "slide",
      spaceBetween: 30,
      on: {
        init: function () {
          $(".swiper-pagination-custom .swiper-pagination-switch").removeClass("active");
          $(".swiper-pagination-custom .swiper-pagination-switch").eq(0).addClass("active");
        },
        slideChangeTransitionStart: function () {
          $(".swiper-pagination-custom .swiper-pagination-switch").removeClass("active");
          $(".swiper-pagination-custom .swiper-pagination-switch").eq(mySwiper.realIndex).addClass("active");
        }
      }
    });
    $(".swiper-pagination-custom .swiper-pagination-switch").on('click', function () {
      mySwiper.slideTo($(this).index());
      $(".swiper-pagination-custom .swiper-pagination-switch").removeClass("active");
      $(this).addClass("active");
    });
  }

  // Slider des actus
  if ($('body .last-post > .swiper').length) {
    const actusSwiper = new Swiper('body .last-post > .swiper', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },

      speed: 400,
      loop: true,
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 40,
      breakpoints: {
        // when window width is >= 768px
        768: {
          loop: false,
          centeredSlides: false,
          slidesPerView: 3,
          spaceBetween: 40,
        }
      }

    })
  }

  // Slider des gallery (programme)
  // if ($('body.single-programme .modal-content > .swiper-container .swiper').length) {
  //   const gallerySwiper = new Swiper('.swiper', {
  //     navigation: {
  //       nextEl: '.swiper-button-next',
  //       prevEl: '.swiper-button-prev',
  //     },

  //     pagination: {
  //       el: '.swiper-pagination',
  //       type: 'bullets',
  //     },

  //     autoHeight: true,
  //     centeredSlides: true,
  //     loop: true,
  //     speed: 400,
  //     slidesPerView: 1,
  //   })
  // }

  // Slider des testimonials
  if ($('body .swiper.testimonial').length) {
    const testiSwiper = new Swiper('.swiper', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    })
  }

  // Swiper de  l'estimation
  if ($('div[id^=wpcf7-f161234] .swiper-container .swiper').length) {
    const estimSwiper = new Swiper(".swiper", {
      modules: [
        Navigation,
        Pagination,
      ],
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      autoHeight: true,
      slidesPerView: 1,
    });
    $('.swiper input').on('change', (e) => {
      estimSwiper.slideNext();
    })
    $('.swiper button[type=submit]').on('click', (e) => {
      // estimSwiper.slideNext();
    })
  }

  // Swiper des programmes [last-programmes] en mobile seulement 
  if (!tablet.matches && !desktop.matches && $('.last-programme-swiper').length && $('div.last-programme > article').length > 1) {
    init = false;
    if (!init) {
      // $('.last-programme-swiper .swiper-wrapper > *:not(.swiper-pagination)').wrap('<div class="swiper-slide"></div>');
      $('div.last-programme > article').appendTo('.last-programme-swiper .swiper-wrapper').wrap('<div class="swiper-slide"></div>');
      init = true;
      const programSwiper = new Swiper('.last-programme-swiper .swiper', {
        slideClass: "swiper-slide",
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },

        speed: 400,
        loop: true,
        slidesPerView: 1,

        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20
          }
        }

      });
    }


  }

  // Bouton de navigation du thème
  if ($('.button.back').length) {
    $('body').on('click', '.button.back', (e) => {
      history.back();
    })
  }

  if ($('#to-top').length) {
    $('body').on('click', '#to-top .button', (e) => {
      gsap.to(window, { duration: 1, scrollTo: 10 });
    })
  }

  // Hauteur 3d single programme 
  // if($( window ).width() > 640) {
  if (desktop.matches) {
    $('.header-banner-programme').height(Math.ceil($(window).height() - ($('#masthead').height() + $('.banner').height())));
  }

  // SEO Content
  if ($('.wp-block-group.seo-content').length && $('.wp-block-group.seo-sub-content').length) {
    $('.wp-block-group.seo-content > .wp-block-group__inner-container > p:first-of-type')
      .append(`<div><button class="button mt-4">Lire la suite</button></div>`)
      .on('click', (e) => {
        $('.wp-block-group.seo-sub-content').slideToggle();
      })
  }
  const $items = $(".navbar-menu .level-0");
  const $target = $("main");
  if ($items && $target) {
    // --- Desktop : hover ---
    $items.hover(
      function () {
        $target.addClass("dimmed");
      },
      function () {
        $target.removeClass("dimmed");
      }
    );

    // --- Mobile : clic/tap ---
    $items.on("click", function (e) {
      // Si déjà actif → on ferme
      if ($(this).hasClass("open")) {
        $(this).removeClass("open");
        $target.removeClass("dimmed");
      } else {
        // Ferme les autres
        $items.removeClass("open");
        // Ajoute sur celui-ci
        $(this).addClass("open");
        $target.addClass("dimmed");
      }
    });

    // Fermer si on clique ailleurs
    $(document).on("click", function (e) {
      if (!$(e.target).closest(".navbar-menu .level-0").length) {
        $items.removeClass("open");
        $target.removeClass("dimmed");
      }
    });
  }

  // Toggle burger & menu
  // Toggle sous-menu sur mobile
  const $menu = $("#primary-menu.navbar-menu");
  const $burger = $(".navbar-burger");
  if ($menu && $burger) {
    $burger.on("click", function () {
      $(this).toggleClass("active");
      $menu.toggleClass("is-menu-mobile-open");
    });
    $menu.on("click", ".level-0 > .navbar-link", function (e) {
      // On empêche le lien parent d’agir directement
      // e.preventDefault();
      const $parent = $(this).parent(".level-0");
      if ($parent.hasClass("open")) {
        // Si déjà ouvert → on ferme
        $parent.removeClass("open");
      } else {
        // Ferme les autres
        $menu.find(".level-0").removeClass("open");
        // Ouvre le bon
        $parent.addClass("open");
      }
    });
  }

  // Mobile menu hierarchy toggle
  $(document).on('click', '#primary-menu .level-0 > .navbar-link', function (e) {
    e.preventDefault();

    const $clickedItem = $(this).closest('.level-0');
    const isAlreadyOpen = $clickedItem.hasClass('open');

    // Ferme tous les menus
    $('#primary-menu .level-0').removeClass('open');

    // Si ce n'était pas déjà ouvert, on l'ouvre
    if (!isAlreadyOpen) {
      $clickedItem.addClass('open');
    }
  });

  // Fermer les menus si clic en dehors
  $(document).on('click', function (e) {
    if (!$(e.target).closest('#primary-menu .level-0').length) {
      $('#primary-menu .level-0').removeClass('open');
    }
  });


  // Realisation gallery
  // Template must contains mandatory HTML tags
  // See /template/archive-realisation.html
  if ($("body.post-type-archive-realisation .wp-block-post").length) {
    const swiperContainer = $('#swiper-realisation-gallery .swiper-wrapper');
    const wpJsonUri = window.location.origin;
    const realisationSwiper = new Swiper(".swiper", {
      modules: [
        Navigation,
        Pagination,
        Manipulation],
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      autoPlay: true,
      autoHeight: false,
      centeredSlides: true,
      loop: true,
      speed: 400,
      slidesPerView: 1,
    });

    $("body.post-type-archive-realisation .wp-block-post").on('click', 'a[rel=realisation-gallery]', function (e) {
      $(e.target).addClass('is-loading');
      e.preventDefault();
      e.stopPropagation();
      // remove logo 
      $('#modal-realisation-gallery img.programme_logo').attr('src', null);

      const el = e.target.closest('.wp-block-post');
      const classList = Array.from(el.classList).filter(c => c.match(/post\-([\d]+)/)).pop();
      const postId = classList?.replace(/post\-([\d]+)/, '$1');
      const link = postId ? `${wpJsonUri}/wp-json/wp/v2/realisation/${postId}/?_fields=acf` : false;
      realisationSwiper.removeAllSlides();
      if (!link) return;

      $.get(link, (data) => {
        const gallery = data?.acf?.realisation_galerie;
        if (!gallery) return;

        // replace logo
        $.get(`${wpJsonUri}/wp-json/wp/v2/media/${data?.acf?.realisation_logo}`, (media) => {
          const logo = media?.guid?.rendered;
          $('#modal-realisation-gallery img.programme_logo').attr('src', logo);
        });
        // Update swiper slides
        gallery.map((item, i) => {
          const sliderItems = [];
          $.get(`${wpJsonUri}/wp-json/wp/v2/media/${item.galery_item_image}`, (media) => {
            // const src = media?.media_details?.sizes?.full?.source_url;
            const src = media?.guid.rendered;
            if (src) sliderItems.push(`<div class="swiper-slide"><img id="${item.galery_item_image}" src="${src}" /></div>`);
          })
            .done(() => {
              realisationSwiper.appendSlide(sliderItems);
              $('#modal-realisation-gallery').addClass('is-active');
            })
            .fail(function (error) {
              console.error('Error loading media:', error);
            });
        });
      }).fail(function (error) {
        console.error('Error loading data:', error);
      });
      $(e.target).removeClass('is-loading');
    });
  }

  // End global Ready wrapper
});
